var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 90,
    viewBox: "0 0 73.0 90.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,28L52,28L52,53.7986C52,55.4555 50.6569,56.7986 49,56.7986C48.6686,56.7986 48.3396,56.7437 48.0261,56.6362L36.5,52.6803L24.9739,56.6362C23.4067,57.174 21.7003,56.3396 21.1625,54.7725C21.0549,54.4591 21,54.13 21,53.7986L21,28Z",
    fill: "#1cb0f6ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333,55.3688l-7.8333,-2.6884l-7.5,2.574l0,-15.2544l15.3333,0l0,15.3688z",
    fill: "#1899d6ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.628,54.0971l-4.128,-1.4168l-3.872,1.3289l0,-12.0092l8,0z",
    fill: "#80d7fcff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36,26m-18,0a18,18 0,1 1,36 0a18,18 0,1 1,-36 0",
    fill: "#ffd900ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2568,17.2734C15.4373,25.9681 18.5787,36.9236 27.2734,41.7432C35.9681,46.5627 46.9236,43.4213 51.7432,34.7266L51.7432,34.7266",
    fill: "#ffc800ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36,40C43.732,40 50,33.732 50,26C50,18.268 43.732,12 36,12C28.268,12 22,18.268 22,26C22,33.732 28.268,40 36,40ZM36,37C29.9249,37 25,32.0751 25,26C25,19.9249 29.9249,15 36,15C42.0751,15 47,19.9249 47,26C47,32.0751 42.0751,37 36,37Z",
    fill: "#ffb100ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank3);
export default __webpack_public_path__ + "static/media/rank3.1f93cfa9a7a30f1f911b89613634c3b2.svg";
export { ForwardRef as ReactComponent };